import { locate } from "./html";

export interface IFocusManager {
	getFocusId(): string;
	setFocusId(id: string): void;
}

class FocusManager implements IFocusManager {
	private _activeWidgetId: string;
	private _initHandler = (e: Event) => (this._activeWidgetId = locate(e, "data-dhx-widget-id"));
	private _removeFocusClass = (e: Event) => {
		const classList = document.body.classList;
		if (classList.contains("utilityfocus")) classList.remove("utilityfocus");
	};
	private _addFocusClass = (e: KeyboardEvent) => {
		const classList = document.body.classList;
		if (e.code === "Tab") {
			if (!classList.contains("utilityfocus")) classList.add("utilityfocus");
		} else {
			if (classList.contains("utilityfocus")) classList.remove("utilityfocus");
		}
	};

	constructor() {
		document.addEventListener("focusin", this._initHandler);
		document.addEventListener("pointerdown", this._initHandler);
		document.addEventListener("mousedown", this._removeFocusClass);
		document.addEventListener("keydown", this._addFocusClass);
	}

	getFocusId(): string {
		return this._activeWidgetId;
	}

	setFocusId(id: string): void {
		this._activeWidgetId = id;
	}
}

export const focusManager = new FocusManager();
